import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Wrench } from "lucide-react";

/**
 * Shows a subtle banner during the daily 02:00-02:10 IST maintenance window,
 * so any transient blip during that ten-minute slot reads as scheduled work
 * instead of a broken app. Polls /api/maintenance/status every 60 seconds.
 */
export default function MaintenanceBanner() {
  const [inWindow, setInWindow] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get("/maintenance/status");
        if (!cancelled) setInWindow(!!data.in_window);
      } catch { /* silent; the retry interceptor handles this */ }
    };
    check();
    const id = setInterval(check, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!inWindow) return null;

  return (
    <div
      data-testid="maintenance-banner"
      className="fixed top-0 inset-x-0 z-50 bg-amber-100 text-amber-900 border-b border-amber-300 px-4 py-2 text-sm text-center font-medium"
    >
      <span className="inline-flex items-center gap-2">
        <Wrench className="w-4 h-4" aria-hidden="true" />
        Scheduled maintenance in progress (02:00-02:10 IST). Brief slowness may occur — normal service resumes shortly.
      </span>
    </div>
  );
}
